import { render } from "./MainSnackbar.vue?vue&type=template&id=6690044a"
import script from "./MainSnackbar.vue?vue&type=script&lang=js"
export * from "./MainSnackbar.vue?vue&type=script&lang=js"

import "./MainSnackbar.vue?vue&type=style&index=0&id=6690044a&lang=scss"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__